

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({
    props: {
        title: String,
        click: Function,
        loading:Boolean
    }
})
export default class DeleteModal extends Vue {
  isOpen = false;
  @Prop(Function) onClick: () => void;
  accept() {
    this.onClick();
    this.isOpen = false;
  }
}
